import { IsoDateCodec } from '@/pages/OperationsAdministration/types/Api/IsoDateCodec';

import { WorkstreamDefinitionSourceSummarySchema } from '@/pages/OperationsAdministration/types/Api/WorkstreamDefinitionSourceSummary';
import { z } from 'zod';

export const WorkstreamDefinitionSourceFeedMetadataSchema = z.object({
    sourceFeedEvaluatedAt: IsoDateCodec,
    sourceFeedLogId: z.string(),
    integrationSourceSummaries: z.array(WorkstreamDefinitionSourceSummarySchema)
});
export type WorkstreamDefinitionSourceFeedMetadata = z.infer<typeof WorkstreamDefinitionSourceFeedMetadataSchema>;